import DatePicker from "react-datepicker";
import styled from "styled-components";

export const AddTaskModelContainer = styled.div`
  max-width: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 16px 20px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
    padding: 30px 40px;
  }
`;

export const SelectTime = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  font-size: 20px;
  font-family: Exo2 Light;
  line-height: 1.3;
  padding: 10px 15px;
  appearance: none;

  @media (min-width: 1024px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const CalenderSetDay = styled(DatePicker)`
  border: none;
  outline: none;
  width: 95px;
  font-size: 20px;
  font-weight: 300;
  line-height: 1.3;
  margin-top: 10px;
  background: transparent;
  color: ${({ theme }) => theme?.colors?.formText};

  &:hover {
    cursor: pointer;
  }
`;

export const HeaderModel = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TitleAddModel = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Regular";
  line-height: 1.2;

  @media (min-width: 1024px) {
    font-size: 20px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const TitleText = styled.h1`
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const CloseButtonAddModel = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f64747;
  border-radius: 50%;
  padding: 10px;
  width: 40px;
  height: 40px;

  cursor: pointer;

  @media (min-width: 1440px) {
    width: 60px;
    height: 60px;
  }
`;

export const ContainerDataTask = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

export const TitleTask = styled.h1`
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const TextCount = styled.span`
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const TextInput = styled.input`
  width: 295px;
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;
  margin-top: 30px;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 16px 20px;

  @media (min-width: 428px) {
    width: 333px;
    font-size: 24px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
  }

  @media (min-width: 1440px) {
    width: 644px;
  }
`;

export const TextDescriptionInput = styled.input`
  width: 295px;
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;
  margin-top: 30px;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 16px 20px 105px;

  @media (min-width: 428px) {
    width: 333px;
    font-size: 24px;
  }

  @media (min-width: 744px) {
    width: 308px;
  }

  @media (min-width: 1024px) {
    width: 269px;
  }

  @media (min-width: 1440px) {
    width: 644px;
  }
`;

export const DataAndTimeContainer = styled.div`
  max-width: 130px;
  gap: 10px;
  display: flex;
  margin-top: 40px;

  @media (min-width: 1024px) {
    max-width: 150px;
  }
`;

export const DateAndTimeInput = styled.input`
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }
`;

export const ContainerRemiderTask = styled.div`
  max-width: 100%;
  display: flex;
  gap: 16px;

  margin-top: 40px;
`;

export const ButtonSelectedTime = styled.button`
  width: 100%;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  color: #808080;
  padding: 16px 10px;
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const ButtonDeletedSelectedTime = styled.button`
  width: 100%;
  background: #f64747;
  border-radius: 20px;
  color: #fff;
  padding: 16px 17px;
  font-size: 20px;
  font-family: "Exo2 ExtraLight";
  line-height: 1.2;

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
  }
`;

export const ContainerButtonSave = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonSave = styled.button`
  width: 100%;
  background: #1ac63f;
  border-radius: 20px;
  font-size: 20px;
  font-family: "Exo2 Bold";
  line-height: 1.2;
  color: #fff;
  padding: 16px 17px;
  margin-top: 60px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    font-size: 24px;
  }

  @media (min-width: 1440px) {
    max-width: 448px;
    font-size: 32px;
    padding: 16px 19px;
  }
`;
